import ApplicationDog from './ApplicationDog.js';
import ApplicationMember from './ApplicationMember.js';

export default class MemberApplication {
    static STATUS_ACTIVE = 'active';
    static STATUS_REJECTED = 'rejected';
    static STATUS_ACCEPTED = 'accepted';

    static fromData(data) {
        if (!data) {
            return;
        }

        const memberApplication = new MemberApplication();
        memberApplication.id = data.id;
        memberApplication.acceptedAt = data.acceptedAt;
        memberApplication.createdAt = data.createdAt;
        memberApplication.doneAt = data.doneAt;
        memberApplication.rejectedAt = data.rejectedAt;
        memberApplication.lastStatusChangeBy = data.lastStatusChangeBy;
        memberApplication.createdBy = data.createdBy;
        memberApplication.type = data.type;
        memberApplication.source = data.source;
        memberApplication.isEditable = data.isEditable;
        memberApplication.status = data.status;
        memberApplication.applicationMembers = data.applicationMembers.data.map((data) => ApplicationMember.fromData(data));
        memberApplication.applicationDogs = data.applicationDogs.data.map((data) => ApplicationDog.fromData(data));

        return memberApplication;
    }

    getDepartments() {
        const departments = [];
        this.applicationMembers.forEach((applicationMember) => {
            applicationMember.departments.forEach((department) => {
                if (!departments.some((element) => element.id === department.id)) {
                    departments.push(department);
                }
            });
        });
        return departments;
    }
}
